import gql from 'graphql-tag'

export const NAME = 'incrementClientAgesByOrgId'
const INCREMENT_CLIENT_AGES_BY_ORG_ID = gql`
  mutation ${NAME}($orgId: ID!) {
    ${NAME}(orgId: $orgId)
  }
`
export default INCREMENT_CLIENT_AGES_BY_ORG_ID
